import Dexie from 'dexie';

export const useDexie = () => {
    const indexedDbInstance = new Dexie(`countercyclical`);

    indexedDbInstance.version(1).stores({
        resources: 'id, type, workspaceId',
        mutations: '++id, entityId, type, payload, createdAt',
    });

    return { indexedDbInstance };
};
